/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-magic-numbers */
/* eslint-disable camelcase */
/* eslint-disable no-inline-comments */
/* eslint-disable no-else-return */
/* eslint no-console: "warn" */
/* eslint no-unused-vars: "warn" */
/* eslint spaced-comment: "warn" */
/* eslint no-magic-numbers: "warn" */

import Axios from 'axios';
import Merkmal from './Merkmal_utils';
import { MerkmalPlacement } from '../utils/statisticsUtils';
import { ERROR_LOG, PROXY_ADR } from './config';

const HOST = PROXY_ADR;

const HTTP_NO_CONTENT_204 = 204;

async function load_destatis_data(code_struct) {
  const table_name = '21311-0001'; // snwt quickhack

  const url = `${HOST}/TabellenExport/${table_name}`;
  // TODO: maybe use fetch for speed? some say it's faster than Axios because Axios uses XMLHTTPRequest, but fetch cannot show progress indicators
  const res_obj = await Axios.get(url);
  const json_data = res_obj.data;
  // const res_obj = await fetch(url);
  // const json_data = await res_obj.json();

  return json_data;

  /*
  if (json_data.returnInfo.inhalt === 'erfolgreich') {
      const map_f = (item) => item[`${methodName_l}Eintraege`][`${methodName_l}Eintraege`];
      const res = map_f(json_data); // unwrap
      return res;
  } else {
      throw json_data;
  }*/
}

async function load_structure_impl(table_structure) {
  const signature = 'load_structure_impl([struct])';
  if (!table_structure.stat_id) {
    if (ERROR_LOG) { console.warn('stat_id missing in table_structure; continuing with:', table_structure.stat_id); }
  }

  const url = `${HOST}/TabelleErgebnis`;

  // await Axios.post will never raise an exception
  const res_obj = await Axios.post(url,
    table_structure,
    { headers: { 'Content-Type': 'application/json' } });
  // field `.status` is only set when status is 200
  const statusCheck = 200;
  if (res_obj.status === statusCheck) {
    const html_data = res_obj.data;
    return html_data;
  }
  /*
      if (res_obj.status) {
          if (ERROR_LOG)
          {console.warn(`${signature} received status ${status}.`);}
          return res_obj.data;
      }
  */
  if (!res_obj.status) {
    const { status } = res_obj.response;
    const err_msg = res_obj.response.data;

    if (err_msg) {
      const emsg = `${signature} received wrapped status ${status}:`;
      console.error(emsg, err_msg);
      throw err_msg;
    }

    if (status) {
      const emsg = `${signature} Axios failed to POST data:`;
      console.error(emsg, res_obj.response);
      throw err_msg;
    }
  }
  /* {
  // check if there is a detailed SOAP response
  const localizedMessage = res_obj.data && res_obj.data.notifications && res_obj.data.notifications[1] & res_obj.data.notifications[1][0] && res_obj.data.notifications[1][0].localizedMessage;

  if (localizedMessage) {
      const emsg = `${signature} received DTO notificaion:`;
      console.warn(emsg, localizedMessage);
      throw localizedMessage;
  }

  if (res_obj.message) {
      // sometime the message will contain the status code among some other text
      const emsg = `${signature} Axios failed to POST data:`;
      console.error(emsg, res_obj.message, res_obj);
      throw (res_obj.message); // this will be shown to the client
  }
  else {
      const emsg = `${signature} received response without status code:`
      console.error(emsg, res_obj);
      throw (emsg + JSON.stringify(res_obj));
  }
} else {
  // pass notification structure as exception
  console.log(`${signature} received status:`,res_obj.status,':');
  const res_data = res_obj.response.data;
  if (res_data && res_data.length > 0) {
      const messages = res_data.map(e => e.localizedMessage || e.message);
      console.log(messages);
      // throw message string
      throw messages.join('\n');
  } else {
      console.log(JSON.stringify(res_obj.response.data));
      // throw notification string as unpacked/delivered by proxy
      throw res_obj.response.data;
  }
}*/
}

async function load_destatis_table_impl(stat_id, code_struct) {
  const signature = `load_destatis_table_impl(${stat_id},[struct])`;
  // delegate html prefiltering to local proxy
  const url = `${HOST}/TabelleErgebnis/${stat_id}`;
  const res_obj = await Axios.get(url);
  const statusCheck = 200;
  if (res_obj.status === statusCheck) {
    const html_data = res_obj.data;
    return html_data;
  } else {
    console.error(`${signature} failed:`, res_obj);
  }
}

async function list_merkmale_for_statistik_impl(five_digit_code) {
  const method_name = 'StatistikMerkmaleKatalog';
  // const field_name = method_name.toMinorCase() + 'Eintraege';
  const signature = `list_merkmale_for_statistik_impl(${five_digit_code})`;

  const url = `${HOST}/${method_name}/${five_digit_code}`;
  if (ERROR_LOG) { console.log(`${signature} invoking URL`, url); }
  const res_obj = await Axios.get(url);
  const json_data = res_obj.data; // axios will ensure that .data is there

  try {
    switch (true) {
      case !json_data: console.error(`${signature} did not receive json data`, res_obj); break;
      // the following is odd. does presence of a returnInfo really signal an error?
      case json_data.returnInfo: console.warn(`${signature} received unexpected .returnInfo`, res_obj); break;
      default: // continue normal control flow
    }
  } catch (emsg) {
    console.error(emsg, res_obj);
    // console.error(emsg, json_data);
    return null;
  }

  return json_data;
  /*
  switch (true)
  {   // return verbatim on failure
      case !json_data:                   console.error(`${method_name} did not return json data`); break;
      case !json_data.returnInfo:        console.error(`${method_name} received json data, but .returnInfo is missing within`); break;
      case !json_data.returnInfo.inhalt: console.error(`${method_name} received json data, but .returnInfo.inhalt is missing within`); break;
      case json_data.returnInfo.inhalt !== 'erfolgreich': console.error(`${method_name} received json data, but .returnInfo.inhalt '${json_data.returnInfo.inhalt}' indicates unsuccessful execution`); break;
      case !json_data[field_name]:       console.error(`${method_name} succeeded, but .${field_name} is missing`); break;
      case !json_data[field_name][field_name]: console.error(`${method_name} succeeded, but .${field_name}.${field_name} is missing`); break;
      default:
          return json_data[field_name][field_name];
  }
  // go here on error
  console.error(`queried URL was ${url}`);
  throw json_data;
  */
}

/** @param {string}  letters_and_digits_code the merkmal code
 *
*/
async function list_auspraegungen_for_merkmal_impl(letters_and_digits_code) {
  const method_name = 'MerkmalAuspraegungenKatalog';
  const strEintraege = 'Eintraege';
  const field_name = method_name[0].toLowerCase() + method_name.slice(1) + strEintraege;

  const url = `${HOST}/MerkmalAuspraegungenKatalog/${letters_and_digits_code}`;
  const res_obj = await Axios.get(url);
  const json_data = res_obj.data; // axios will ensure that .data is there

  // return a default if server returns empty response
  if (res_obj.status === HTTP_NO_CONTENT_204) { return []; }

  /* eslint-disable no-throw-literal */
  try {
    switch (true) { // return verbatim on failure
      case !json_data: throw `${method_name}(${letters_and_digits_code}) did not return json data`;
      case !json_data.returnInfo: throw `${method_name}(${letters_and_digits_code}) received json data, but .returnInfo is missing within`;
      case !json_data.returnInfo.inhalt: throw `${method_name}(${letters_and_digits_code}) received json data, but .returnInfo.inhalt is missing within`;
      case json_data.returnInfo.inhalt !== 'erfolgreich': throw `${method_name}(${letters_and_digits_code}) received json data, but .returnInfo.inhalt '${json_data.returnInfo.inhalt}' indicates unsuccessful execution`;
      case !json_data[field_name]: throw `${method_name}(${letters_and_digits_code}) succeeded, but .${field_name} is missing`;
      case !json_data[field_name][field_name]: throw `${method_name}(${letters_and_digits_code}) succeeded, but .${field_name}.${field_name} is missing`;
      default:
        return json_data[field_name][field_name];
    }
  }
  catch (emsg) {
    // go here on error
    console.error(emsg, JSON.stringify(json_data));
    console.error('queried URL was ', url);
    throw json_data;
  }
  /* eslint-enable no-throw-literal */
}

/* async function list_auspraegungen_for_merkmal_bulk_stream_impl(letters_and_digits_code_ary)
{
    const url = `${HOST}/MerkmalAuspraegungenKatalog_bulk/${letters_and_digits_code_ary.join('/')}`;
    return Axios({method: 'get'
          , url
          , responseType: 'stream'
        }).then( response => {
            response.data.pipe( f => {
                console.log("stramed", f);
            });
        }).catch(exn => { console.error('stream error:', exn)});
}*/

async function list_auspraegungen_for_merkmal_bulk_async_impl(letters_and_digits_code_ary) {
  const method_name = 'MerkmalAuspraegungenKatalog';
  const strEintraege = 'Eintraege';
  const field_name = method_name.toMinorCase() + strEintraege;

  const url = `${HOST}/MerkmalAuspraegungenKatalog_bulk/${letters_and_digits_code_ary.join('/')}`;
  const res_obj = await Axios.get(url);
  const json_data = res_obj.data;

  /* eslint-disable no-throw-literal */
  const signature = `${method_name}(${JSON.stringify(letters_and_digits_code_ary)})`;
  try {
    switch (true) {
      // general failures
      case !json_data: throw `${signature} did not return json data`;
      case !json_data.returnInfo: throw `${signature} received json data, but .returnInfo is missing within`;
      case !json_data.returnInfo.inhalt: throw `${signature} received json data, but .returnInfo.inhalt is missing within`;
      case json_data.returnInfo.inhalt !== 'erfolgreich': throw `${signature} received json data, but .returnInfo.inhalt '${json_data.returnInfo.inhalt}' indicates unsuccessful execution`;
      default: // continue normal flow after catch
    }
  }
  catch (emsg) {
    console.error(emsg, json_data);
    return []; // FIXME: is this right?
  }
  /* eslint-enable no-throw-literal */

  // unwrap ary
  function map_f(k, json_item) {
    /* eslint-disable no-throw-literal */
    const signature = `${method_name}/${k}`;
    try {
      switch (true) { // individual failures
        case !json_item[field_name]: throw `${signature} succeeded, but .${field_name} is missing`;
        case !json_item[field_name][field_name]: throw `${signature} succeeded, but .${field_name}.${field_name} is missing`;
        default:
          return json_item[field_name][field_name];
      }
    }
    catch (emsg) {
      console.error(emsg, json_item);
      // console.error(`queried URL was: `,url); // maybe do not log excessively
      return null;
    }
    /* eslint-enable no-throw-literal */
  }
  // TODO: handle individual failures ?
  const res = Object.entries(json_data)
    .map(([k, v]) => [k, map_f(k, v)])
    .filter(([_, v]) => v) // filter out errors, i.e. where mapping returned null
    .reduce((a, [k, v]) => Object.assign(a, { [k]: map_f(k, v) }), {}); // collect into mapping
  return res;
}

/** Simulate streaming by updating a backbuffer continuously while parts of the subquery trickle in
 * @param {string} five_digit_code statistic code (e.g. 21311)
 * @param {function<object,void>} setAuspraegungenMap callback for updating the backbuffer; e.g. setAuspraegungenMap({"GES": ["GESW","GESM"]})
 * @return {Promise<void>} barrier that waits for all subqueries to finish
 */
async function list_auspraegungen_for_statistik_impl(five_digit_code, setAuspraegungenMap) {
  // first, get all merkmale as a set of candidates
  const list_merkmale_json = await list_merkmale_for_statistik_impl(five_digit_code);
  // filter non-enums and get the merkmals-code
  const merkmal_code_list = list_merkmale_json.filter(Merkmal.has_auspraegungen).map(m => m.code);
  // fetch enum items (auspraegungen) for KMm merkmals-code
  async function list_auspraegungen_for_merkmal_i(mcode) {
    try {
      const auspraegungen_i = await list_auspraegungen_for_merkmal_impl(mcode);
      setAuspraegungenMap({ [mcode]: auspraegungen_i }); // submit for amendment
    } catch (exn) {
      console.warn(`partial list_auspraegungen_for_merkmal_async_impl(${mcode}) failed:`, exn);
    }
  }

  const merkmal_promise_list = merkmal_code_list.map(mcode => list_auspraegungen_for_merkmal_i(mcode)); // build a list of promises
  return Promise.all(merkmal_promise_list);
}

async function list_zeitscheiben_for_statistik_impl(five_digit_code, setZeitscheibenMap) {
  const signature = `list_zeitscheiben_for_merkmal_async_impl(${five_digit_code})`;
  // first, get all merkmale as a set of candidates
  const list_merkmale_json = await list_merkmale_for_statistik_impl(five_digit_code);
  // filter non-enums and get the merkmals-code
  const merkmal_code_list = list_merkmale_json.filter(Merkmal.has_zeitscheiben).map(m => m.code);

  async function list_zeitscheiben_for_merkmal_i(mcode) {
    try {
      const zeitscheiben_i = await list_zeitscheiben_for_merkmal_impl(mcode);
      setZeitscheibenMap({ [mcode]: zeitscheiben_i }); // submit
    } catch (exn) {
      console.warn(`partial ${signature} failed:`, exn);
    }
  }

  const merkmal_promise_list = merkmal_code_list.filter(e => e).map(mcode => list_zeitscheiben_for_merkmal_i(mcode)); // build a list of promises
  return Promise.all(merkmal_promise_list);
}

async function list_einheiten_for_statistik_impl(five_digit_code, setEinheitenMap) {
  const signature = `list_einheiten_for_merkmal_async_impl(${five_digit_code})`;
  // first, get all merkmale as a set of candidates
  const list_merkmale_json = await list_merkmale_for_statistik_impl(five_digit_code);
  // filter non-enums and get the merkmals-code
  const merkmal_code_list = list_merkmale_json.filter(Merkmal.has_unit).map(m => m.code);

  async function list_einheiten_for_merkmal_i(mcode) {
    try {
      const einheiten_i = await list_einheiten_for_merkmal_impl(mcode);
      setEinheitenMap({ [mcode]: einheiten_i }); // submit
    } catch (exn) {
      console.warn(`partial ${signature} failed:`, exn);
    }
  }

  const merkmal_promise_list = merkmal_code_list.filter(e => e).map(mcode => list_einheiten_for_merkmal_i(mcode)); // build a list of promises
  return Promise.all(merkmal_promise_list);
}

async function list_merkmale_with_auspraegungen_for_statistik_impl(five_digit_code) {
  // fetch merkmale
  const list_merkmale_json = await list_merkmale_for_statistik_impl(five_digit_code);

  const list_merkmale_with_auspraegungen = list_merkmale_json; // in-place modified below
  // query Auspraegungen for appropriate Merkmale
  {
    // filter non-enums and get the merkmals-code
    const merkmal_code_list = list_merkmale_json.filter(Merkmal.has_auspraegungen).map(m => m.code);
    // fetch enum items (auspraegungen) for KMm merkmals-code
    const bulk_obj = await list_auspraegungen_for_merkmal_bulk_async_impl(merkmal_code_list);
    // unmap the auspraegungen to their respective merkmal
    list_merkmale_with_auspraegungen.forEach(m => {
      const auspraegungen_i = bulk_obj[m.code];
      if (Merkmal.has_auspraegungen(m)) {
        if (!auspraegungen_i) {
          // eslint-disable-next-line no-console
          if (ERROR_LOG) { console.warn(`list_merkmale_with_auspraegungen_for_statistik_impl failed to unmap Ausprägungen for code ${m.code}`); }
        } else {
          Object.assign(m, { auspraegungen: auspraegungen_i });
        }
      }
    });
  }

  // query timeslices for appropriate Merkmale
  {
    const merkmal_code_list = list_merkmale_json.filter(Merkmal.has_zeitscheiben).map(m => m.code);
    // fetch timeslice candidates for KMm merkmals-code
    const bulk_obj = await list_zeitscheiben_for_merkmal_bulk_async_impl(merkmal_code_list);
    // unmap the timeslices to their respective merkmal
    list_merkmale_with_auspraegungen.forEach(merkmal => {
      const timeslices_i = bulk_obj[merkmal.code];
      if (Merkmal.has_zeitscheiben(merkmal)) {
        if (!timeslices_i) {
          // eslint-disable-next-line no-console
          if (ERROR_LOG) { console.warn(`list_merkmale_with_auspraegungen_for_statistik_impl failed to unmap Zeitscheiben for code ${merkmal.code}`); }
        } else {
          Object.assign(merkmal, { zeitscheiben: timeslices_i });
          Object.assign(merkmal, { auspraegungen: timeslices_i }); // TODO: remove in production
        }
      }
    });
  }

  // query units for appropriate Merkmale
  {
    const merkmal_code_list = list_merkmale_json.filter(Merkmal.has_unit).map(m => m.code);
    // fetch unit candidates for KMm merkmals-code
    const bulk_obj = await list_unit_for_merkmal_bulk_async_impl(merkmal_code_list);
    // unmap the unit to their respective merkmal
    list_merkmale_with_auspraegungen.forEach(merkmal => {
      const unit_i = bulk_obj[merkmal.code];
      if (Merkmal.has_unit(merkmal)) {
        if (!unit_i) {
          // eslint-disable-next-line no-console
          if (ERROR_LOG) { console.warn(`list_merkmale_with_auspraegungen_for_statistik_impl failed to unmap Größeneinheit for code ${merkmal.code}`); }
        } else {
          Object.assign(merkmal, { unit: unit_i });
          Object.assign(merkmal, { auspraegungen: unit_i }); // TODO: remove in production
        }
      }
    });
  }

  return list_merkmale_with_auspraegungen;
}

// mock service call
async function list_zeitscheiben_for_merkmal_impl(merkmal_code) {
  // TODO: what format does our api deliver?
  return [2015, 2016, 2017, 2018].map(y => ({ code: `${y}-10P6M`, inhalt: `WS ${y}/${(y + 1) % 100}` }));
}

async function list_einheiten_for_merkmal_impl(merkmal_code) {
  return [{ code: 'STK', inhalt: '1' }];
}

// mock service call
async function list_zeitscheiben_for_merkmal_bulk_async_impl(merkmal_code_list) {
  if (!merkmal_code_list) { return {}; }
  // mock
  return merkmal_code_list.map(mcode => {
    return [mcode,
      [2015, 2016, 2017, 2018].map(y => ({ code: `${y}-10P6M`, inhalt: `WS ${y}/${(y + 1) % 100}` })),
    ];
  }).reduce((a, [k, v]) => Object.assign(a, { [k]: v }), {});
}

// mock service call
async function list_unit_for_merkmal_bulk_async_impl(merkmal_code_list) {
  if (!merkmal_code_list) { return {}; }
  // mock
  return merkmal_code_list.map(mcode => {
    return [mcode, [{ code: 'EA', inhalt: 'Stück' }]];
  }).reduce((a, [k, v]) => Object.assign(a, { [k]: v }), {});
}

// monoize this

// return a sorted list of recommended (pre-computed)-tables to attempt to build
const recommend_table = function (set_dict, val_set) {
  return set_dict
    // map (what?) to non-matched merkmale
    .map(([k, vset]) => [k, vset.filter(v => !val_set.includes(v))])
    // sort ascending by length (shorter remaining vals lists are better)
    .sort(([_k1, vs1], [_k2, vs2]) => vs1.length - vs2.length);
};

// count how often a merkmal is used in recommended tables
const recommend_merkmal = function (set_dict, val_set) {
  const rec_dict = recommend_table(set_dict, val_set);
  const cnt_map = rec_dict.reduce((a, [_tbl_id, ms]) => {
    ms.forEach(m => { if (!a[m]) { a[m] = 0; } a[m]++; });
    return a;
  }, {});

  const max_n = Object.values(cnt_map).reduce((a, e) => Math.max(a, e), 1); // cannot be 0

  const rel_dict = Object.entries(cnt_map).map(([k, n]) => [k, n / max_n]);
  if (ERROR_LOG) { console.debug('recommend_merkmal(..,..) built rel_dict:', rel_dict); }

  const rel_map = rel_dict.reduce((a, [k, n]) => { a[k] = n; return a; }, {});
  return rel_map;
};

const list_merkmale_recommended_for_merkmale_async_impl = async (merkmal_code_list) => {
  // do local caching of map (statistik -> map( table -> [merkmal]))

  // TODO: make variable and memoize
  // const tabellen_code_list = ["21311-0001","21311-0002","21311-0003","21311-0004","21311-0005","21311-0006","21311-0007","21311-0008","21311-0009","21311-0010","21311-0011","21311-0012","21311-0013","21311-0014","21311-0015"];

  const method = 'TabelleMerkmaleKatalog_bulk';
  const url = `${HOST}/${method}/${merkmal_code_list.join('/')}`;
  const res_obj = await Axios.get(url);
  const json_data = res_obj.data;
  // const res_obj = await fetch(url);
  // const json_data = await res_obj.json();

  const tabelle_merkmal_map = json_data;

  const tabelle_merkmal_dict = Object.entries(tabelle_merkmal_map);

  const recs = recommend_merkmal(tabelle_merkmal_dict, merkmal_code_list);
  return recs;

  /*
  const method_lower = `recommendMerkmalMerkmal_bulk`;
  const method = `recommendMerkmalMerkmal_bulk`;
  const url = `http://localhost:3000/${method}/${merkmal_code_list.join('/')}`;
  const res_obj = await fetch(url);
  const json_data = await res_obj.json();

  console.log(json_data);
  return json_data;
  */
};

export default class Destatis {
  static async load_data(code_struct /* : any*/) { // expect keys: {vals: T, rows: T, cols: T, titles: T} where T = [Code_String]
    return load_destatis_data(code_struct);
  }

  static async load_structure(table_structure) {
    return load_structure_impl(table_structure);
  }

  static async load_table(stat_id, code_struct) {
    return load_destatis_table_impl(stat_id, code_struct);
    // return <DestatisTable_21311_0002 />;
  }

  /**
   * @param {int} five_digit_code a string of 5 digits, more or less
   * @return {Promise<Merkmal[]>} a promise, containing an array of objects {code:string, inhalt:string, links:string, auspraegungen: T[]}
   */
  static async list_merkmale_for_statistik(five_digit_code) {
    return list_merkmale_for_statistik_impl(five_digit_code);
  }

  static async list_auspraegungen_for_merkmal(letters_and_digits_code) {
    return list_auspraegungen_for_merkmal_impl(letters_and_digits_code);
  }

  /**
   * @param {string} five_digit_code e.g. "21311"
   * @param {function} setAuspraegungenMap callback to an updater that can add results-trickling-in to a buffer
   * @return {Promisve<void>} nothing
   */
  static async list_auspraegungen_for_statistik(five_digit_code, setAuspraegungenMap) {
    return list_auspraegungen_for_statistik_impl(five_digit_code, setAuspraegungenMap);
  }

  static async list_zeitscheiben_for_statistik(five_digit_code, setZeitscheibenMap) {
    return list_zeitscheiben_for_statistik_impl(five_digit_code, setZeitscheibenMap);
  }

  static async list_einheiten_for_statistik(five_digit_code, setEinheitenMap) {
    return list_einheiten_for_statistik_impl(five_digit_code, setEinheitenMap);
  }

  // compose list_merkmal_for_statistik * list_auspraegungen_for_merkmal
  static async list_merkmale_with_auspraegungen_for_statistik(five_digit_code) {
    return list_merkmale_with_auspraegungen_for_statistik_impl(five_digit_code);
  }

  static async list_merkmale_recommended_for_merkmale(code_list) {
    return list_merkmale_recommended_for_merkmale_async_impl(code_list);
  }

  /**
   * @param {integer} stat_id
   * @param {Merkmal[]} vals
   * @param {Merkmal[]} titles
   * @param {Merkmal[]} rows
   * @param {Merkmal[]} cols
   * @return {string} a URL suffix
   */
  // static build_fragment(stat_id, vals, titles, rows, cols)

  static lift_code_to_merkmal(merkmale_list, item) {
    if (!merkmale_list) { // console.warn(`failed to lift code '${item}' because Merkmale are not yet loaded`);
      return null;
    }
    const merkmal = merkmale_list && merkmale_list.find(m => m.code === item /* || m.inhalt === item*/);
    if (!merkmal) { console.error(`failed to lift code '${JSON.stringify(item)}' after Merkmale were loaded`); } // eslint-disable-line no-console

    return merkmal;
  }

  /**
   * Create a map for looking up parts of a JSON structure for merkmale by code (mcodes and macode).
   * The JSON structure is a list of merkmale, e.g. [{code: 'some-mcode', .., auspraegungen: [{code: 'some-acode', ..}, ..]}, ..]
   * A `mcode` is the code for a Merkmal, wrapped in rectangular brackets, e.g. "[GES]". It uniquely identifies a Merkmal.
   * A `acode` is the code for a Ausprägung, wrapped in rectangular brackets, e.g. "[GESW]". It identifies an Auspraegung WITHIN THE SCOPE of its Merkmal.
   * A `macode` is the concatenation of `mcode` and `acode`, e.g. "[GES].[GESW]". It uniquely identifies an Auspraegung.
   * @param {object[]} merkmale as obtained from webservice e.g. StatistikMerkmalKatalog
   * @param {object} auspraegungen_map as obtained from webservice
   * @return {Record<mcode|macode,object>} a map from `mcode`|`macode` strings to subtrees of the input structure, i.e. props.merkmale
   */
  static build_macodeMap(merkmaleIn, auspraegungen_map) {
    // console.log('448#5.4', merkmaleIn, auspraegungen_map);
    // 448 hier ist das Problem, die VALUEs merkmaleIn (props) sind aus der Statistik und nicht aus den Kennzahlen
    let merkmale = merkmaleIn;
    if (merkmale) {
      const index = merkmale.findIndex(merkmale => merkmale === null);
      merkmale[index] = [];
      // console.log('448#5.5', index);
      const arr2 = []; // 2651
      for (let ii = 0; ii < merkmale.length; ii += 1) {
        if (!Array.isArray(merkmale[ii]) && merkmale[ii] !== null) {
          arr2.push(merkmale[ii]);
        }
      }
      merkmale = arr2;
    }
    // console.log('448#5.6.0', merkmale);
    // merkmale.splice(-2);
    const macodeMap = (merkmale || []).reduce((acc1, m) => {
      // add macodes to map
      const m_auspraegungen_cleaned = merkmale //.filter((item) => !Array.isArray(item) || item.length > 0);
      // const m_auspraegungen_cleaned = (auspraegungen_map[m.code] || []).filter(e => e); // filter empty entries
      // const m_auspraegungen_cleaned = (m.auspraegungen||[]).filter(e=>e); // filter empty entries
      const acc1a = m_auspraegungen_cleaned.reduce((acc2, a) => {
        /*
        console.log('448#5.6', m, a);
        console.log('448#5.6.1', m.code);
        console.log('448#5.6.2', a.code);
        */
        const macode = Destatis.bracketize_macode(m.code, a.code); // TODO: use rendering function
        acc2[macode] = a;
        return acc2;
      }, acc1);
      // also add mcodes to map
      acc1a[Destatis.bracketize_mcode(m.code)] = m;
      return acc1a;
    }, {});
    if (ERROR_LOG) { console.debug('macodeMap built.'); }
    // console.log('448#5.8', macodeMap);
    return macodeMap;
  }

  /* bracketized codes are used for lookups internally, where a primitive type is needed as a hashtable key */
  static bracketize_mcode(raw_mcode) { return `[${raw_mcode}]`; }

  static bracketize_macode(raw_mcode, raw_acode) { return `[${raw_mcode}].[${raw_acode}]`; }

  /* prettyprint is used for strings shown to the user */
  static prettyprint_code(code) { return `[${code}]`; } // use this on graph nodes' .code

  static prettyprint_merkmal(m) {
    // Else: Rückgabe einer leeren Überschrift 448
    // console.log('448#0', m);
    return m && (m.inhalt ? `${m.inhalt} [${m.code}]` : (m.code ? `[${m.code}]` : '...'));
  }

  static prettyprint_auspraegung(m, a) { return a && a.inhalt ? `${a.inhalt}` : `[${a.code}]`; }

  // migration helper to move from lists (unterordnung by default) to sortable treeviews
  /**
   * Convert a list of merkmal codes into a tree structure by buildingn a subordinate relation between each successive pair.
   * @param {string[]} code_ary an array of codes
   * @return {T[]} a list of tree nodes T = {code: string, children: T[]}
   */
  static ary_to_unterordnung(code_ary /* : string[] */) {
    if (code_ary === null) { return null; }
    if (code_ary.length === 0) { return code_ary; }
    if (!(code_ary instanceof Array)) { return Destatis.ary_to_unterordnung([code_ary]); }

    const [hd, tl] = [code_ary[0], code_ary.slice(1)];
    return { title: hd, code: hd, children: Destatis.ary_to_unterordnung(tl) };
  }

  /* Convert a list of merkmal instances into a tree structure by building a subordinate relation between each successive pair */
  static merkmale_to_tree1(merkmale_ary) {
    if (!merkmale_ary) { return []; }
    if (merkmale_ary.length === 0) { return merkmale_ary; }
    if (!(merkmale_ary instanceof Array)) { return this.merkmale_to_tree1([merkmale_ary]); }

    return merkmale_ary.map(m => {
      // console.log('448#8');
      const m_label = Destatis.prettyprint_merkmal(m);
      const m_children = Destatis.merkmale_to_tree1(m.children);
      return ({ title: m_label, code: m.code, children: m_children });
    });
  }

  /** Build a title like "Studierende: Deutschland insgesamt, Geschlecht, Nationalität, Semester"
   * from a list of Merkmale. The order of Merkmale in the string is determined by their type.
   * Therefore Merkmale must have been loaded, otherwise prettyprinting is unpretty
   * @param {Merkmale[]} usedMerkmale array of Merkmale used in the table preview
   * @return {string} a prettyprinted title string
   * */
  static prettyprint_ad_hoc_title(usedMerkmale) {
    // partition into 'before colon', 'after colon'
    const [werte, unwerte] = usedMerkmale.partition(Merkmal.is_Wert);
    // sort title by 1.Wert (was), 2.Ort (wo), 3.Zeit (wann)
    unwerte.sort(Merkmal.title_cmp);
    return [werte, unwerte].map(mm => mm.map(m => m.inhalt).join(', ')).join(': '); // insert commas and a colon
  }

  //
  //
  /** show merkmal name in header by default for Merkmale in columns
   *  use Tree.forEach to apply this function to all nodes in a tree (default for cols)
   *  @param {T} treeData of type T = {code: string, children: T[], title:string, id:string, filter: string[] }
   *  @return {T} treeData with properties `.merkmal_placement`, `.show_merkmal_name_in_header`, and `.show_merkmal_name_in_nwblock` set
   */
  static place_merkmal_in_nwbox(treeData) {
    treeData.merkmal_placement = treeData.merkmal_placement || MerkmalPlacement.NWBlock;
    treeData.show_merkmal_name_in_header = false; // (treeData.merkmal_placement === MerkmalPlacement.Header);
    treeData.show_merkmal_name_in_nwblock = true; // (treeData.merkmal_placement === MerkmalPlacement.NWBlock);
    return treeData;
  }

  // use Tree.forEach to apply this function to all nodes in a tree (default for titles,rows)
  // show merkmal name in nwblock by default for Merkmale in rows, titles, (and vals)
  static place_merkmal_in_header(treeData) {
    treeData.merkmal_placement = treeData.merkmal_placement || MerkmalPlacement.Header;
    treeData.show_merkmal_name_in_header = true; // (treeData.merkmal_placement === MerkmalPlacement.Header);
    treeData.show_merkmal_name_in_nwblock = false; // (treeData.merkmal_placement === MerkmalPlacement.NWBlock);
    return treeData;
  }

  // use Tree.forEach to apply this function to all nodes in a tree (default for filters/vals)
  static place_merkmal_offscreen(treeData) {
    treeData.merkmal_placement = treeData.merkmal_placement || MerkmalPlacement.None;
    treeData.show_merkmal_name_in_header = false; // (treeData.merkmal_placement === MerkmalPlacement.Header);
    treeData.show_merkmal_name_in_nwblock = false; // (treeData.merkmal_placement === MerkmalPlacement.NWBlock);
    return treeData;
  }

  /** Build an serialized key to identify client-rendered table previews,
   *  because big preview tables can be expensive to build.
   *  For use in TableRenderer::render().
   * @param {object} props properties for renderer
   * @returns {string} a key to a hashmap
   */
  static build_cache_key_for_renderer(props) {
    // console.log('cache_key#8 build_cache_key_for_renderer');
    const struct_projection = {
      // unique_id: Math.random().toString().substr(2, 8),
      stat_id: props.stat_id,
      col_graph: props.col_graph,
      val_graph: props.val_graph,
      title_graph: props.title_graph,
      row_graph: props.row_graph,
      // , select_map : props.select_map // ... but selections should be incorporated in the graphs
      merkmale_length: (props.merkmale || []).length, // renderer needs to update when merkmale have finished downloading
      auspraegungenMap_length: Object.keys(props.auspraegungenMap || {}).length, // renderer needs to update when auspraegungen have finished loading
    };
    if (!props.col_graph) struct_projection.unique_id = Math.random().toString().substr(2, 8);
    // console.log('cache_key#8', struct_projection);
    return JSON.stringify(struct_projection);
  }

  static build_cache_key_for_query(props) {
    // console.log('cache_key#8 build_cache_key_for_query');
    return this.build_cache_key_for_renderer(props);
  }

  /** Project this array of all properties to those that represent a state */
  static get_current_structure(props) {
    if (!props.stat_id) {
      if (ERROR_LOG) { console.warn('get_current_structure could not find stat_id'); }
    }
    const struct_projection = {
      stat_id: props.stat_id,
      col_graph: props.col_graph,
      val_graph: props.val_graph,
      title_graph: props.title_graph,
      row_graph: props.row_graph,

      merkmale_length: (props.merkmale || []).length, // renderer needs to update when merkmale have finished downloading
      auspraegungenMap_length: Object.keys(props.auspraegungenMap || {}).length, // renderer needs to update when auspraegungen have finished loading
    };
    return struct_projection;
  }

  static get_current_structure_for_loading(props) { return Destatis.get_current_structure(props); }

  // flattening is NOT url building, but building the (legacy) lists of merkmale (e.g. cols as opposed to col_graph)
  // this should be deprecated
  static project_graphs_for_flattening(query_graph) {
    return {
      cols: query_graph.col_graph,
      vals: query_graph.val_graph,
      titles: query_graph.title_graph,
      rows: query_graph.row_graph,
    }; // ignore stat_id, select_map
  }

  static project_graphs_for_title(query_graph) {
    return {
      col_graph: query_graph.col_graph,
      val_graph: query_graph.val_graph,
      title_graph: query_graph.title_graph,
      row_graph: query_graph.row_graph,
    }; // ignore stat_id, select_map in title
  }

  static project_graphs_for_history(query_graph) {
    return Destatis.get_current_structure(query_graph);
    // return Destatis.project_graphs_for_title(query_graph);
  }
}

function test_ary_to_unterordnung() {
  const test1 = ['HELLO', 'WORLD'];
  if (ERROR_LOG) { console.debug('test_ary_to_unterordnung 1:', Destatis.ary_to_unterordnung(test1)); }
}
// test_ary_to_unterordnung();
